import React, { useState } from 'react';
import styled from 'styled-components';
import { FaCode } from 'react-icons/fa';
import { TEMPLATE_VARIABLES } from '../utils/templateUtils';

const Wrapper = styled.div`
  margin-bottom: ${p => p.theme.spacing(1.5)};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;

  span {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${p => p.theme.colors.textSecondary};
  }

  svg {
    color: ${p => p.theme.colors.textSecondary};
    font-size: 11px;
  }
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  background: ${p => p.theme.colors.surface};
  border: 1px solid ${p => p.theme.colors.inputGray}44;
  border-radius: 16px;
  color: ${p => p.theme.colors.primary};
  font-size: 0.76rem;
  font-weight: 500;
  font-family: 'Roboto Mono', monospace;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: ${p => p.theme.colors.primary}18;
    border-color: ${p => p.theme.colors.primary}66;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Tooltip = styled.div`
  position: fixed;
  padding: 6px 10px;
  background: ${p => p.theme.colors.background};
  border: 1px solid ${p => p.theme.colors.inputGray}66;
  border-radius: 6px;
  color: ${p => p.theme.colors.textSecondary};
  font-size: 0.75rem;
  pointer-events: none;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  max-width: 200px;
`;

const VariableInserter = ({ onInsert }) => {
  const [tooltip, setTooltip] = useState(null);

  const handleMouseEnter = (e, variable) => {
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      text: variable.description,
      x: rect.left,
      y: rect.bottom + 6,
    });
  };

  const handleMouseLeave = () => {
    setTooltip(null);
  };

  return (
    <Wrapper>
      <Header>
        <FaCode />
        <span>Insert Variable</span>
      </Header>
      <ChipRow>
        {TEMPLATE_VARIABLES.map(v => (
          <Chip
            key={v.key}
            type="button"
            onClick={() => onInsert(`{${v.key}}`)}
            onMouseEnter={(e) => handleMouseEnter(e, v)}
            onMouseLeave={handleMouseLeave}
          >
            {`{${v.key}}`}
          </Chip>
        ))}
      </ChipRow>
      {tooltip && (
        <Tooltip style={{ left: tooltip.x, top: tooltip.y }}>
          {tooltip.text}
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default VariableInserter;
